// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import { PointerSensor, useSensor, useSensors } from '@dnd-kit/core';

// A drag starts only once the pointer has moved this far. A plain click on a folder or project
// card therefore never starts one, so the drag overlay never appears under a click and the card's
// own pointer-up handler still runs. Same threshold the cards use for their click-vs-drag test.
export const DRAG_ACTIVATION_DISTANCE = 5;

export const useDashboardDragSensors = () => useSensors(
  useSensor(PointerSensor, { activationConstraint: { distance: DRAG_ACTIVATION_DISTANCE } }),
);
